import Button from 'components/Button';
import Error from 'components/form/Error';
import Input from 'components/form/Inputs/Input';
import Modal from 'components/Modal';
import Typography from 'components/Typography';
import { FC, useState } from 'react';
import styled from 'styled-components';
import { mutate } from 'swr';
import privateAPI from 'utils/privateAxiosInstance';

const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  button {
    margin-left: auto;
    margin-right: 0;
    margin-top: 1rem;
  }
  p {
    margin-bottom: 0.5rem;
  }
  & > div {
    width: 100%;
  }
`;

type Props = {
  open: boolean;
  close: () => void;
};
const Create: FC<Props> = ({ open, close }) => {
  const [name, setName] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<'general' | 'name' | null>(null);

  const handleChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    setName(e.target.value);
  };
  const handleSubmit: React.FormEventHandler = (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    privateAPI
      .post('/mentorship-referee', { name })
      .then(() => {
        setName('');
        close();
        mutate('/mentorship-referee');
      })
      .catch((err) => {
        if (
          err?.response?.data?.fields?.length &&
          err.response.data.fields.includes('name')
        ) {
          return setError('name');
        }
        setError('general');
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return (
    <Modal open={open} close={close}>
      <Form onSubmit={handleSubmit}>
        <Typography
          variant="h2"
          color="primary"
          style={{ marginBottom: '1rem' }}
        >
          Ajouter un chargé de mentorat
        </Typography>
        {error &&
          (error === 'general' ? (
            <Error>Une erreur est survenue.</Error>
          ) : (
            <Error>Ce chargé de mentorat existe déjà.</Error>
          ))}
        <Input
          placeholder="Nom"
          value={name}
          onChange={handleChange}
          required
        />
        <Button color="primary" loading={loading}>
          Ajouter
        </Button>
      </Form>
    </Modal>
  );
};

export default Create;
